import { lightTheme, type Theme } from "@rainbow-me/rainbowkit";

const baseTheme = lightTheme({
  accentColor: "var(--purple)",
  accentColorForeground: "var(--inverse-foreground)",
  borderRadius: "small",
  fontStack: "system",
  overlayBlur: "small",
});

export const oursRainbowKitTheme: Theme = {
  ...baseTheme,
  colors: {
    ...baseTheme.colors,
    actionButtonBorder: "var(--line)",
    actionButtonBorderMobile: "var(--line)",
    actionButtonSecondaryBackground: "var(--surface-muted)",
    closeButton: "var(--ink)",
    closeButtonBackground: "var(--surface-muted)",
    connectButtonBackground: "var(--acid)",
    connectButtonInnerBackground: "var(--acid)",
    connectButtonText: "var(--accent-ink)",
    connectionIndicator: "var(--success)",
    downloadBottomCardBackground: "var(--surface-muted)",
    downloadTopCardBackground: "var(--surface-raised)",
    error: "var(--danger)",
    generalBorder: "var(--line)",
    generalBorderDim: "var(--line)",
    menuItemBackground: "var(--surface-muted)",
    modalBackdrop: "var(--scrim)",
    modalBackground: "var(--surface)",
    modalBorder: "var(--line)",
    modalText: "var(--ink)",
    modalTextDim: "var(--muted)",
    modalTextSecondary: "var(--muted)",
    profileAction: "var(--surface-muted)",
    profileActionHover: "var(--purple-soft)",
    profileForeground: "var(--surface-raised)",
    selectedOptionBorder: "var(--purple)",
    standby: "var(--warning)",
  },
  shadows: {
    ...baseTheme.shadows,
    connectButton: "none",
    dialog: "var(--shadow-dialog)",
    profileDetailsAction: "none",
    selectedOption: "0 0 0 2px var(--purple-soft)",
    selectedWallet: "0 0 0 2px var(--purple-soft)",
    walletLogo: "0 1px 0 rgb(0 0 0 / 8%)",
  },
  fonts: {
    body: "var(--font-body)",
  },
  radii: {
    actionButton: "6px",
    connectButton: "6px",
    menuButton: "8px",
    modal: "14px",
    modalMobile: "16px",
  },
};
